import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
} from "../../../../ui/AlertDialog/AlertDialog";
import { Button } from "../../../../ui/Button";
import { t } from "i18next";
import React, { useEffect } from "react";
import { useFetch } from "../../../../hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "../../../../stores/RootStore";

type Props = {
  id: string;
  isDeleteOpen: boolean;
  closeModal: Function;
};

const DeleteType = ({ id, isDeleteOpen, closeModal }: Props) => {
  const [{ response: itemDeleteResponse, isLoading: itemDeleteIsLoading, error: itemDeleteError }, doFetchItemDelete] =
    useFetch(`/directories/equipment_types/${id}`);
  
  const setEquipmentTypes = useAppStore(store => store.setEquipmentTypes)
  const equipmentTypes = useAppStore((store) => store.equipmentTypes);
  
  const deleteType = () => {
    setEquipmentTypes(equipmentTypes?.filter((type) => type.id != id)!);
  }

  const navigate = useNavigate();
  useEffect(() => {
    if (itemDeleteResponse) {
      deleteType();
      navigate("..", { relative: "path" });
      closeModal();
    }
  }, [itemDeleteResponse]);

  const onDelete = () => {
    doFetchItemDelete({
      method: "DELETE",
    });
  };

  const openStateChange = () => {
    if (isDeleteOpen) closeModal();
  };

  return (
    <AlertDialog open={isDeleteOpen} onOpenChange={openStateChange}>
      <AlertDialogContent style={{ maxWidth: 450 }}>
        <AlertDialogTitle>Удалить тип оборудования</AlertDialogTitle>
        <AlertDialogDescription>Вы уверены, что хотите удалить тип оборудования?</AlertDialogDescription>

        <div className="flex justify-between mt-4">
          <Button variant={"destructive"} size={"md"} className="px-3" onClick={onDelete}>
            {t("delete")}
          </Button>
          <AlertDialogCancel className="h-8">{t("cancel")}</AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteType;
